export default {
  getBodyDamageDictionary: (axios) =>
    axios.get('/api/digitalCertificates/dictionaries/bodyDamages'),
  getBodyElementsDictionary: (axios) =>
    axios.get('/api/digitalCertificates/dictionaries/bodyElements'),
  getBodyPaintworkThicknessDictionary: (axios) =>
    axios.get('/api/digitalCertificates/dictionaries/bodyPaintworkThickness'),
  getCarEquipmentDictionary: (axios, digitalCertificateId) =>
    axios.get(`/api/digitalCertificates/dictionaries/carEquipments`, {
      params: { digitalCertificateId },
    }),
  getTechnicalConditionsDictionary: (axios) =>
    axios.get('/api/digitalCertificates/dictionaries/technicalConditions'),
  getTyresWearDictionary: (axios) =>
    axios.get('/api/digitalCertificates/dictionaries/carTyresWearStates'),
  getInteriorElementsDictionary: (axios) =>
    axios.get('/api/digitalCertificates/dictionaries/interiorElements'),
  getInteriorDamageDictionary: (axios) =>
    axios.get('/api/digitalCertificates/dictionaries/interiorDamages'),
}
